module.exports = __webpack_public_path__ + "img/AGTRANSPARENT.07dfad21.png";